module.exports = __webpack_public_path__ + "img/gepax_platform_logo.98da4e0c.png";